import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { SignInCompletedResponse } from './SignInCompletedResponse'
import { MiniAppAccountChoiceResponse } from './MiniAppAccountChoiceResponse'
/**
* Class MiniAppAuthResponse
*  Результат входа через Mini App: либо сессия, либо выбор аккаунта
*/
export class MiniAppAuthResponse extends ActiveModel {

  /**
  * completed
  * Если значение присутствует, авторизация завершена<br>  */
  @ActiveField({
    factory: [SignInCompletedResponse, () => undefined]
  })
  completed?: null | SignInCompletedResponse


  /**
  * accountChoice
  * Если значение присутствует, нужно выбрать аккаунт (только Telegram)<br>  */
  @ActiveField({
    factory: [MiniAppAccountChoiceResponse, () => undefined]
  })
  accountChoice?: null | MiniAppAccountChoiceResponse
}
